"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Navigation = require("./Navigation.styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _Item = require("./Item");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

let level = 0;

const Navigation = ({
  links,
  orientation,
  className,
  onClick,
  title,
  total,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_Navigation.StyledNav, _extends({
    className: (0, _classnames.default)({
      [orientation]: orientation,
      [className]: className
    })
  }, props), title ? /*#__PURE__*/_react.default.createElement(_Navigation.StyledHead, null, /*#__PURE__*/_react.default.createElement(_Navigation.StyledH1, null, title, " ", total ? /*#__PURE__*/_react.default.createElement("span", null, "(", total, ")") : null)) : null, /*#__PURE__*/_react.default.createElement(_Navigation.StyledUL, {
    className: (0, _classnames.default)(`level-0`)
  }, links.map((link, index) => {
    if (link.children) level += 1;
    return /*#__PURE__*/_react.default.createElement(_Item.Item, _extends({}, link, {
      key: link.id ? link.id : index,
      index: index,
      level: level,
      onClick: onClick
    }));
  })));
};

exports.Navigation = Navigation;
Navigation.propTypes = {
  orientation: _propTypes.default.string,

  /** If a component is provided in the linkComponent attribute then the url and label attributes are not required. */
  links: _propTypes.default.arrayOf(_propTypes.default.object),
  className: _propTypes.default.string,

  /** A callback handler which will return event, label and id. Only used when
   * the client does not provide a component for the links. */
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  total: _propTypes.default.number
};